import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import ReportServices from "./ReportServices";

const initialState = {
  dayReports: [],
  itemReports: [],
  inventoryInOutReports: [],
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
};
export const getDayReports = createAsyncThunk(
  "report/getDayReports",
  async (_, thunkAPI) => {
    try {
      return await ReportServices.getDayReports();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getItemReports = createAsyncThunk(
  "report/getItemReports",
  async (_, thunkAPI) => {
    try {
      return await ReportServices.getItemReports();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getInventoryInOutReport = createAsyncThunk(
  "report/getInventoryInOutReport",
  async (_, thunkAPI) => {
    try {
      return await ReportServices.getInventoryInOutReport();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const reportSlice = createSlice({
  name: "report",
  initialState,
  reducers: {
    RESET_REPORT(state) {
      state.isError = false;
      state.isSuccess = false;
      state.isLoading = false;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(getDayReports.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(getDayReports.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.dayReports = action.payload.data;
      })

      .addCase(getDayReports.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        toast.error(action.payload);
      })

      .addCase(getItemReports.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(getItemReports.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.itemReports = action.payload.data;
      })

      .addCase(getItemReports.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        toast.error(action.payload);
      })
      .addCase(getInventoryInOutReport.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(getInventoryInOutReport.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.inventoryInOutReports = action.payload.data;
      })

      .addCase(getInventoryInOutReport.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        toast.error(action.payload);
      });
  },
});

export const { RESET_REPORT } = reportSlice.actions;
export const selectDayReports = (state) => state.report.dayReports;
export const selectItemReports = (state) => state.report.itemReports;
export const selectInventoryInOutReports = (state) =>
  state.report.inventoryInOutReports;
export const selectReportLoading = (state) => state.report.isLoading;

export default reportSlice.reducer;
